import React, { useContext, useState } from "react";
import { Link, useNavigate } from "@reach/router";
import { RfxContext } from "newui/features/Rfx/context/RfxContext";
import { CustomModal } from "components/RFQ/Modal/CustomModal";
import { Button } from "newui/components/Button";

interface AppMenuLinkProps {
  children: React.ReactNode;
  className?: string;
  exactLink?: boolean;
  newTab?: boolean;
  testId?: string;
  to: string;
  onNavigate?: () => void;
}

export const AppMenuLink: React.FC<AppMenuLinkProps> = ({
  to,
  newTab = false,
  exactLink = false,
  testId,
  className,
  children,
  onNavigate,
}) => {
  const { setUploadInProgresses, uploadInProgresses } = useContext(RfxContext);
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const navigate = useNavigate();

  const isActive = ({ isPartiallyCurrent }: { isPartiallyCurrent: boolean }) => {
    const url = new URL(window.location.href);
    const getLastLink = (urls: string) => urls?.split("/").pop();
    const isExact = getLastLink(url.pathname) === getLastLink(to);

    if (exactLink ? isExact : isPartiallyCurrent) {
      if (isExact) {
        return {
          style: {
            backgroundColor: "rgba(0, 69, 245, 0.2)",
            color: "#0045F5",
          },
        };
      }
    }

    return {};
  };

  const handleLinkClick = (e: React.MouseEvent) => {
    if (
      uploadInProgresses?.rfxBidder?.length > 0 ||
      uploadInProgresses?.rfxProcurer?.length > 0
    ) {
      e.preventDefault();
      setWarningModalOpen(true);
    } else if (onNavigate) {
      onNavigate();
    }
  };

  const FooterComponent = () => {
    return (
      <div className="flex w-full justify-between gap-2 text-utility-error-50">
        <Button
          onClick={() => {
            setWarningModalOpen(false);
          }}
          btntype="base"
          className="!w-full"
        >
          Cancel
        </Button>
        <Button
          className="flex !w-full gap-3"
          onClick={() => {
            setWarningModalOpen(false);
            if (uploadInProgresses?.rfxBidder?.length) {
              setUploadInProgresses({ ...uploadInProgresses, rfxBidder: [] });
            } else {
              setUploadInProgresses({ ...uploadInProgresses, rfxProcurer: [] });
            }
            navigate(to);
            if (onNavigate) {
              onNavigate();
            }
          }}
        >
          Yes
        </Button>
      </div>
    );
  };

  const linkClass = `flex w-full items-center text-gray-500 font-medium ${className ?? ""}`;

  return (
    <>
      {newTab ? (
        <a
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
          data-testid={testId}
        >
          {children}
        </a>
      ) : (
        <Link
          getProps={isActive}
          to={to}
          className={linkClass}
          onClick={handleLinkClick}
          data-testid={testId}
        >
          {children}
        </Link>
      )}
      <CustomModal
        isOpen={isWarningModalOpen}
        onClose={() => setWarningModalOpen(false)}
        header={{
          icon: "warning",
          bgColor: "bg-utility-error-50",
          iconColor: "text-utility-error-500",
          title: "Are your sure to leave current page?",
          description:
            "Are you sure you want to leave this page? Some of your changes haven't been saved.",
        }}
        footerComponent={<FooterComponent />}
      >
        {null}
      </CustomModal>
    </>
  );
};
